import React from "react";
import '../css/CustomLoader.css';
import DataTable from "react-data-table-component";

const CustomLoader = ({ isLoading }) => {
    return (
        <div className={`loading ${isLoading ? 'active' : ''}`}>
            <div className="loading-inner">Loading...</div>
        </div>
    );
};

const customStyles = {
	headRow: {
		style: {
            backgroundColor: '#03539c',
            color: 'white',
            borderTopLeftRadius: '10px',
            borderTopRightRadius: '10px',
            maxHeight: '36px',
            minHeight: '36px'
		},
	},
	cells: {
		style: {
            maxHeight: '36px',
            minHeight: '36px',
			color: '#02539B',
            fontWeight: 'bold',
            fontSize: '12px',
            '&:not(:last-of-type)': {
                maxHeight: '36px',
                minHeight: '36px',
            }
		},
	},
    rows: {
        style: {
            borderRight: '1px solid #e5e5e5',
            borderLeft: '1px solid #e5e5e5',
            maxHeight: '36px',
            minHeight: '36px',
            '&:not(:last-of-type)': {
                maxHeight: '36px',
                minHeight: '36px',
            }
        }
    },
    pagination: {
        style: {
            backgroundColor: '#eaeaea',
            borderRight: '1px solid #e5e5e5',
            borderLeft: '1px solid #e5e5e5',
            borderBottom: '1px solid #e5e5e5',
            minHeight: '36px'
        }
    }
};

function DataTableBase(props) {

    const hasData = props.data && props.data.length > 0;

    const getRowStyle = (index) => {
        return {
            backgroundColor: (index % 2 == 0) ? '#f2f6fa' : '',
        };
    };

    const conditionalRowStyles = [
        {
            when: row => props.data.indexOf(row) % 2 === 0,
            style: getRowStyle(0)
        },
        {
            when: row => props.data.indexOf(row) % 2 !== 0,
            style: getRowStyle(1)
        }
    ];

    return (
        <div style={{ position: 'relative' }}>
            <DataTable
                pagination
                paginationServer
                paginationRowsPerPageOptions={[5, 10, 20, 25, 50, 100]}
                sortServer
                customStyles={customStyles}
                persistTableHead={true}
                sortIcon={<></>}
                conditionalRowStyles={conditionalRowStyles}
                className={!props.data.length ? 'd-none' : ''}
                {...props}
            />
            {hasData && <CustomLoader isLoading={props.isLoading} />}
        </div>
    );
}

export default DataTableBase;